import PRODUCT_ACTION_TYPES from './product.types';

export const PRODUCT_INITIAL_STATE = {
  productList: [],
};

export const ProductReducer = (state = PRODUCT_INITIAL_STATE, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case PRODUCT_ACTION_TYPES.LOAD_PRODUCTS: {
      return { ...state, productList: payload };
    }
    default:
      return state;
  }
};
